/**
 * @aveo/ui — the dashboard's design system, as far as modules need it.
 *
 * Deliberately NOT part of @aveo/module-sdk. That package is the CONTRACT: what a
 * module is, how the guard works, which permissions exist. This one is the LOOK,
 * and it knows shadcn, Radix and class-variance-authority. Keeping them apart is
 * what lets the contract outlive whichever component library the dashboard
 * happens to use — the reason stated in @aveo/module-sdk/ui for refusing form
 * controls there.
 *
 * The host does not keep a second copy: src/components/ui re-exports from here,
 * so every button in the dashboard and every button in a module is the same
 * component.
 *
 * Only what a module actually needs. It grows when a second module needs
 * something, not in anticipation.
 *
 * The class names live in this package, so tailwind.config.ts must scan
 * packages/ui/src — otherwise every button in the dashboard renders unstyled.
 */

export { Button, buttonVariants } from './Button'
export { Input } from './Input'
export { Badge, badgeVariants } from './Badge'
export { FileDrop } from './FileDrop'
export type { FileDropProps, FileRejection } from './FileDrop'
export { Section } from './Section'
export { Select, Textarea } from './Select'
export { Checkbox, Field, Label } from './Field'
export { Notice, noticeVariants } from './Notice'
export { Panel, panelVariants } from './Panel'
export { Stack } from './Stack'
export { Table, TableBody, TableCell, TableHead, TableHeaderCell, TableRow } from './Table'
export { Dialog } from './Dialog'
export { NavTab, NavTabs } from './NavTabs'
export { cn } from './cn'
